import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const MIN_LENGTH = 2;
const MAX_LENGTH = 50;
const ALLOWED_CHARS_REGEX = /^[a-zA-Z0-9_-]+$/;
const HAS_LETTER_REGEX = /[a-zA-Z]/;

export function categoryNameFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string;

    if (!value) {
      return null;
    }

    if (value !== value.trim()) {
      return { leadingOrTrailingSpaces: true };
    }

    if (value.length < MIN_LENGTH || value.length > MAX_LENGTH) {
      return { invalidLength: true };
    }

    if (!ALLOWED_CHARS_REGEX.test(value)) {
      return { invalidFormat: true };
    }

    if (!HAS_LETTER_REGEX.test(value)) {
      return { numericOnly: true };
    }

    return null;
  };
}
